import { graphql, Link, useStaticQuery } from "gatsby";
import { CircleTeaser } from "../CircleTeaser";
import * as React from "react";

export function CircleTeasers() {
  const data = useStaticQuery(graphql`
    {
      teaserOne: file(relativePath: { eq: "teaser01.jpg" }) {
        ...TeaserImage
      }
      teaserTwo: file(relativePath: { eq: "teaser02.jpg" }) {
        ...TeaserImage
      }
      teaserThree: file(relativePath: { eq: "teaser03.jpg" }) {
        ...TeaserImage
      }
    }
  `);
  return (
    <section
      className={
        "grid gap-8 xl:grid-cols-3 justify-center justify-items-center p-8"
      }
    >
      <Link
        to="/ueber-uns"
        title="Kindergarten von Fokus Familie in Moers | Über uns"
      >
        <CircleTeaser
          image={{
            image: data.teaserOne.childImageSharp.gatsbyImageData,
            title: "Fokus Familie gemeinnützige GmbH",
            alt: "Fokus Familie gemeinnützige GmbH",
          }}
          title={"Über uns"}
        >
          Wir engagieren uns seit über 10 Jahren für eine familiennahe und
          zeitgemäße Kinderbetreuung in Moers. Überzeugen Sie sich selbst und
          machen Sie einen Termin.
        </CircleTeaser>
      </Link>

      <Link
        to="/paedagogisches-konzept"
        title="Kinderbetreuung in und um Moers | Pädagogisches Konzept"
      >
        <CircleTeaser
          image={{
            image: data.teaserTwo.childImageSharp.gatsbyImageData,
            title: "Fokus Familie gemeinnützige GmbH",
            alt: "Fokus Familie gemeinnützige GmbH",
          }}
          title={"Pädagogisches Konzept"}
        >
          Auf dieser Seite erfahren Sie mehr über unser pädagogisches Konzept.
        </CircleTeaser>
      </Link>

      <Link
        to="/alltag"
        title="Fokus Familie | Unser Alltag in den Kindergartenstätten"
      >
        <CircleTeaser
          image={{
            image: data.teaserThree.childImageSharp.gatsbyImageData,
            title: "Fokus Familie gemeinnützige GmbH",
            alt: "Fokus Familie gemeinnützige GmbH",
          }}
          title={"Unser Alltag"}
        >
          Schauen Sie sich hier unseren Alltag an.
        </CircleTeaser>
      </Link>
    </section>
  );
}
